import React, { useCallback, useMemo, useState } from 'react';
import { Header } from '../../components/layout/header';
import { Editable } from '../home/home';
import { useParams } from 'react-router-dom';
import { ValuationApi } from '../../apis';
import { message } from 'antd';
import { AdditionalForm } from '../../components/valuation/additional';

const AppraisalSendValuationScreen = () => {
  const [loading, setLoading] = useState(false);
  const [action, setAction] = useState<{ payload: any }>({
    payload: undefined,
  });

  const [payload, setPayload] = useState<any>({
    type: undefined,
    vin: undefined,
    plateNumber: undefined,

    carBrand: {
      id: undefined,
      createdBy: undefined,
      createdAt: undefined,
      updatedBy: undefined,
      updatedAt: undefined,
      deletedBy: undefined,
      deletedAt: undefined,
      name: undefined,
      nameLower: undefined,
      source: undefined,
      sourceUrl: undefined,
      formerId: undefined,
    },

    carModel: {
      id: undefined,
      createdBy: undefined,
      createdAt: undefined,
      updatedBy: undefined,
      updatedAt: undefined,
      deletedBy: undefined,
      deletedAt: undefined,
      carBrandId: undefined,
      name: undefined,
      nameLower: undefined,
      source: undefined,
      sourceUrl: undefined,
      score: undefined,
      formerId: undefined,
      formerCarBrandId: undefined,
    },

    engineCapacity: undefined,
    condition: undefined,
    steering: undefined,
    engineType: undefined,
    drivetrain: undefined,
    exteriorColor: undefined,
    manufacturedYear: undefined,
    importedYear: undefined,
    manufacturedCountry: undefined,
    customsNo: undefined,
    customsUrl: undefined,
  });
  const [messageaApi, contextHolder] = message.useMessage();

  const param = useParams();

  const reload = useCallback(async () => {
    setLoading(true);
    if (param?.id) {
      try {
        const res = await ValuationApi.get(param?.id);
        setAction({
          payload: res,
        });
        const { vehicle } = res;
        setPayload({
          type: vehicle?.type,
          vin: vehicle?.vin,
          plateNumber: vehicle?.plateNumber,
          carBrand: vehicle?.carBrand,
          carModel: vehicle?.carModel,
          odo: vehicle?.odo,
          interiorColor: vehicle?.interiorColor,
          transmission: vehicle?.transmission,
          engineCapacity: vehicle?.engineCapacity,
          condition: vehicle?.condition,
          steering: vehicle?.steering,
          engineType: vehicle?.engineType,
          drivetrain: vehicle?.drivetrain,
          exteriorColor: vehicle?.exteriorColor,
          manufacturedYear: vehicle?.manufacturedYear,
          importedYear: vehicle?.importedYear,
          manufacturedCountry: vehicle?.manufacturedCountry,
          customsNo: vehicle?.customsNo,
          customsUrl: vehicle?.customsUrl,
        });
        setLoading(false);
      } catch (e: any) {
        messageaApi.error(e.message);
        console.log(e);
        setLoading(false);
      }
    }
  }, [messageaApi, param?.id]);

  const additionalFormInitData = useMemo(() => {
    if (!action?.payload) {
      return {};
    }

    const { payload: _payload } = action;

    return {
      ..._payload,
    };
  }, [action]);

  React.useEffect(() => {
    reload();
  }, [reload]);

  if (loading === true) {
    return <div>Loading...</div>;
  }

  if (!payload || payload?.isComparable === true) {
    return <div>NOT FOUND</div>;
  }

  return (
    <>
      {contextHolder}
      <div className="">
        <div className="flex-col  rounded-[8px] p-5 bg-white">
          <Header title="Үнэлгээчин рүү илгээх" isGoBack={false} />
        </div>
        <div className="flex flex-row gap-[50px]">
          <div className="w-[520px]">
            {payload && (
              <Editable
                payload={payload}
                setPayload={(e: any) => {}}
                key={gen10DigitKey()}
                additionalInfoHide={true}
                disabled={true}
              />
            )}
          </div>
          <div className="flex flex-1 w-full flex-col mt-[25px] ">
            <div className="rotate-0 opacity-100 pt-[21px] pr-[21px] pl-[21px] gap-4 rounded-[10px] border border-[#E5E7EB] bg-white pb-[20px]">
              <AdditionalForm action={action as any} payload={additionalFormInitData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function gen10DigitKey() {
  const n = Math.floor(Math.random() * 9_000_000_000) + 1_000_000_000;
  return String(n);
}

export { AppraisalSendValuationScreen };
